import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-organization-list',
  templateUrl: './organization-list.component.html',
  styleUrls: ['./organization-list.component.scss'],
})
export class OrganizationListComponent extends BaseListCtl {
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.orgnization')
      .then((property: string) => {
        _self.initApiEndpoint(property);
    _self.display();
      });
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.address = data.address;
    form.phone = data.phone;
  }

  display() {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.user')
      .then((property: string) => {
        let url = property + '/organization';
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
            alert('Server Error:' + error);
        return;
      }
      _self.form.error = !res.success;
          _self.form.message = res.message;

      if (res.success) {
        _self.populateForm(_self.form.data, res.result.data);
      }
    });

        let url1 = property + '/uc';
    this.locator.http.get(url1, function (res: any, error: boolean) {
      if (error) {
            alert('Server Error:' + error);
        return;
      }
        });
    });
  }
}
